import { MotifDatePicker } from "@ey-xd/motif-react";
import {
  formatDateOnly,
  toDateOnly,
} from "../../../../../../utils/dateFunction";
import "./ProvisionDatePicker.scss";

interface ProvisionDatePickerProps {
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
}

const ProvisionDatePicker = ({
  selectedDate,
  onDateChange,
}: ProvisionDatePickerProps) => (
  <div className="sku-provision-date-picker">
    <label className="motif-label-outside">
      Provision completion date (required)
    </label>
    <MotifDatePicker
      dayPlaceholder="DD"
      format="dd/MM/yyyy"
      monthPlaceholder="MM"
      value={selectedDate}
      yearPlaceholder="YYYY"
      onChange={(date) => {
        onDateChange(date instanceof Date ? date : null);
      }}
    />
    {selectedDate && (
      <span className="sku-provision-date-picker__helper">
        Date format: {formatDateOnly(toDateOnly(selectedDate))}
      </span>
    )}
  </div>
);

export default ProvisionDatePicker;
